import { useContext, useState } from 'react'

import Axios from 'axios'
import { Button, Col, Form, Modal } from 'react-bootstrap'

import { toast } from 'react-toastify'

import DashboardContext from '../../../Context';

export default function ModalCustomSms({ sohwitem, handelClosemodal, id }) {

    const { urldashboard, authentication, handelerrors } = useContext(DashboardContext);

    const [lodinForm, setLodinForm] = useState(false)


    const [Formdata, setFormdata] = useState({ orderId: id })


    const PostForm = async () => {
        try {
            const data = await Axios.post(`${urldashboard}/order/sendworkersmswithmessage`, JSON.stringify(Formdata), {
                headers: {
                    "Authorization": authentication,
                    "content-type": "application/json; charset=utf-8"
                }
            })
            toast.success(data.message, {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            setLodinForm(false)
            handelClosemodal()

        } catch (error) {
            handelerrors(error)
            setLodinForm(false)

        }
    }

    const handelValue = (name, vlaue) => {
        setFormdata({ ...Formdata, [name]: vlaue })
    }

    const handelSendForm = () => {
        setLodinForm(true)
        if (!Formdata.message) {
            toast.error('لطفا متن پیام را وارد کنید', {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            setLodinForm(false)
        }
        else {
            PostForm()
        }
    }

    return (
        <Modal show={sohwitem} onHide={handelClosemodal}  >
            <Modal.Header >
                <Modal.Title>ارسال پیام دلخواه به نیروهای سفارش</Modal.Title>
                <i className="fa fa-times mr-auto"
                    style={{ fontSize: '16px', cursor: 'pointer' }}
                    onClick={handelClosemodal} aria-hidden="true"></i>
            </Modal.Header>
            <Modal.Body>
                <Col>
                    <Form.Label>متن پیام دلخواه</Form.Label>
                    <Form.Control as="textarea" rows={5} name='message' onChange={e => handelValue('message', e.target.value)} />
                </Col>
            </Modal.Body>
            <Modal.Footer>
                <Button disabled={lodinForm} onClick={handelClosemodal} variant="danger">انصراف</Button>
                <Button disabled={lodinForm} onClick={handelSendForm} variant="success" className='mr-auto' >
                    {lodinForm ? <i className="fa fa-spinner fa-pulse fa-fw"></i> : 'ثبت'}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
